import { memo } from 'react';
import { Button, FilterIcon } from '@quickmd-llc/design-system';
import { Events, EventAction, tracking } from '@lib';
import { useFilters } from './useFilters';

function FiltersButton() {
  const { hour, provider, showFilters, setShowFilters, timeOfDay } =
    useFilters();
  const priority = showFilters ? 'primary' : 'tertiary';
  const text = getButtonText(
    [hour, provider, timeOfDay].map(Boolean).filter(Boolean),
  );

  function handleClick() {
    setShowFilters(!showFilters);

    tracking.trackEvent(Events.TOGGLE_FILTERS, {
      Action: showFilters ? EventAction.CLOSE : EventAction.OPEN,
    });
  }

  return (
    <Button
      priority={priority}
      size="s"
      onClick={handleClick}
      className="shrink-0"
    >
      <FilterIcon />
      {text}
    </Button>
  );
}

function getButtonText(filters: boolean[]): string {
  if (filters.length === 0) {
    return 'Filters';
  }

  return `Filters (${filters.length})`;
}

export default memo(FiltersButton);
